'use client'
import React, { useState } from 'react';
import classes from './LoanCalculator.module.css';

/* const savingsProducts = [
    {
        category: "Savings Accounts",
        subItems: [
            { name: "Free Kasasa Saver®", rate: 2.5 },
            { name: "Badlands® Savings", rate: 3.0 },
            { name: "Badlands Gold® Savings", rate: 3.2 },
            { name: "Christmas Club Savings", rate: 3.7 },
            { name: "Pee Wee Penguin Savings", rate: 4.2 },
            { name: "Business Money Market Savings", rate: 3.0 },
        ],
    },
    {
        category: "Retirement Accounts",
        subItems: [
            { name: "IRA", rate: 4.0 },
            { name: "CD", rate: 5.5 },
        ],
    },
]; */


export function Calculator() {
    const [isLoanCalculator, setIsLoanCalculator] = useState(true);
    const [loanInterestRate, setLoanInterestRate] = useState(null);
    const [savingsInterestRate, setSavingsInterestRate] = useState(null);

    return (
        <div className={classes.mainContainer}> {/* Remove This Div */}

            <div className={classes.calculatorContainer}>
                <div className={classes.calculatorContainerLeft}>
                    <div className={classes.leftHeader}>
                        <h2>Products:</h2>

                        <div className={classes.toggleContainer}>
                            <div className={`${classes.toggleBackground} ${isLoanCalculator ? classes.loanActive : classes.savingsActive}`}>
                                <div className={classes.toggleSlider}></div>
                            </div>
                            <button className={`${classes.toggleButton} ${isLoanCalculator ? classes.active : ""}`} onClick={() => setIsLoanCalculator(true)}>
                                Loans
                            </button>
                            <button className={`${classes.toggleButton} ${!isLoanCalculator ? classes.active : ""}`} onClick={() => setIsLoanCalculator(false)}>
                                Savings
                            </button>
                        </div>
                    </div>

                    {isLoanCalculator
                        ? <LoanTypes />
                        : <SavingsTypes />}

                </div>

                {isLoanCalculator
                    ? <LoanCalculator interestRate={loanInterestRate} setInterestRate={setLoanInterestRate} />
                    : <SavingsCalculator interestRate={savingsInterestRate} setInterestRate={setSavingsInterestRate} />}

            </div>
            {/* Remove This Div */} </div>

    );
}

function LoanTypes() {
    /* const [openCategory, setOpenCategory] = useState(null);
    const [activeSubItem, setActiveSubItem] = useState(null); */

    return (
        <div className={classes.loanSection}>
            <div className={`feature-block ${classes.featureBlock}`}>
                <h2>Get an Estimate</h2>
                <p>Interest rates are often a dynamic piece of what dictates your monthly payment. Fill out our Loan Inquiry Form or give us a call to find out what you may qualify for.</p>
                <a href="https://internetloanapplication.cudl.com/dakotawest/" rel="noreferrer" target="_blank" class="btn btn-primary">Loan Inquiry Form</a>
            </div>
            {/*             {loanProducts.map((product, index) => (
                <div key={index} className={classes.accordionItem}>
                    <div className={`${classes.accordionHeader} ${openCategory === index ? classes.open : ""}`} onClick={() => setOpenCategory(openCategory === index ? null : index)}>
                        {product.category}
                    </div>
                    <div className={`${classes.accordionContent} ${openCategory === index ? classes.expanded : classes.collapsed}`}>
                        {product.subItems.map((item, idx) => (
                            <div
                                key={idx}
                                className={`${classes.accordionSubitem} ${activeSubItem === item.name ? classes.active : ""}`}
                                onClick={() => {
                                    setInterestRate(item.rate);
                                    setActiveSubItem(item.name);
                                }}
                            >
                                <p>{item.name} ({item.rate}%)</p>
                            </div>
                        ))}
                    </div>
                </div>
            ))} */}
        </div>
    );
}

function SavingsTypes() {
    //const [openCategory, setOpenCategory] = useState(null);
    //const [activeSubItem, setActiveSubItem] = useState(null);

    return (
        <div className={classes.loanSection}>
            <div className={`feature-block ${classes.featureBlock}`}>
                <h2>Get an Estimate</h2>
                <p>Interest rates are often a dynamic piece of what dictates your monthly payment. Along with our estimate calculator, our Current Rates may help you visualize what the life of your loan will look like.</p>
                <a href='https://dakotawestcu.com/current-rates/' className="btn btn-primary">Current Rates</a>
            </div>
            {/* {savingsProducts.map((product, index) => (
                <div key={index} className={classes.accordionItem}>
                    <div className={`${classes.accordionHeader} ${openCategory === index ? classes.open : ""}`} onClick={() => setOpenCategory(openCategory === index ? null : index)}>
                        {product.category}
                    </div>
                    <div className={`${classes.accordionContent} ${openCategory === index ? classes.expanded : classes.collapsed}`}>
                        {product.subItems.map((item, idx) => (
                            <div
                                key={idx}
                                className={`${classes.accordionSubitem} ${activeSubItem === item.name ? classes.active : ""}`}
                                onClick={() => {
                                    setInterestRate(item.rate);
                                    setActiveSubItem(item.name);
                                }}
                            >
                                <p>{item.name} ({item.rate}%)</p>
                            </div>
                        ))}
                    </div>
                </div>
            ))} */}
        </div>
    );
}

function LoanCalculator({ interestRate, setInterestRate }) {
    const [loanAmount, setLoanAmount] = useState(null);
    const [paymentSchedule, setPaymentSchedule] = useState('Monthly');
    const [years, setYears] = useState(1);
    const [months, setMonths] = useState(0);

    //correction for 'payment schedule' in results
    const getPeriodLabel = () => {
        switch (paymentSchedule) {
            case 'Annually':
                return '/yr';
            case 'Quarterly':
                return '/qtr';
            default:
                return '/mo';
        }
    };

    // Helpers
    const periodsPerYear = { Monthly: 12, Quarterly: 4, Annually: 1 };
    const paymentPeriods = periodsPerYear[paymentSchedule] || 1;
    const periodicInterestRate = interestRate / 100 / paymentPeriods;

    // Convert total term into years (e.g., 2 years 6 months = 2.5 years)
    const totalYears = years + months / 12;
    const totalPayments = totalYears * paymentPeriods;

    // Calculate Monthly Payment
    const calculateMonthlyPayment = () => {
        if (periodicInterestRate === 0) return loanAmount / totalPayments;
        return (loanAmount * periodicInterestRate) / (1 - Math.pow(1 + periodicInterestRate, -totalPayments));
    };

    const monthlyPayment = calculateMonthlyPayment();
    const totalPayment = monthlyPayment * totalPayments;
    const totalInterest = totalPayment - loanAmount;

    // Calculate Monthly Interest (First Payment)
    const monthlyInterest = loanAmount * periodicInterestRate;
    const principalPercentage = (loanAmount / totalPayment) * 100 || 0;
    const interestPercentage = (totalInterest / totalPayment) * 100 || 0;

    return (
        <div className={classes.calculator}>
            <div className={classes.calculatorContent}>

                {/* Right Side - Loan Form */}
                <div className={classes.calculatorForm}>
                    <div className={classes.inputGroup}>
                        <label>Loan Amount</label>
                        <input type="number" aria-label="loan amount" onChange={(e) => setLoanAmount(parseFloat(e.target.value) || 0)} />
                    </div>
                    <div className={classes.inputGroup}>
                        <label>Payment Schedule</label>
                        <select onChange={(e) => setPaymentSchedule(e.target.value)} aria-label="payment schedule">
                            <option value="Monthly">Monthly</option>
                            <option value="Quarterly">Quarterly</option>
                            <option value="Annually">Annually</option>
                        </select>
                    </div>
                    <div className={classes.inputGroup}>
                        <label>Loan Term</label>
                        <div className={classes.doubleInput}>
                            <div className={classes.inputGroup}>
                                <label>Years</label>
                                <input type="number" min="0" aria-label="loan term years" onChange={(e) => setYears(parseInt(e.target.value) || 0)} placeholder="Years" />
                            </div>
                            <div className={classes.inputGroup}>
                                <label>Months</label>
                                <input type="number" min="0" max="11" aria-label="loan term months" onChange={(e) => setMonths(parseInt(e.target.value) || 0)} placeholder="Months" />
                            </div>
                        </div>
                    </div>
                    <div className={classes.inputGroup}>
                        <label>Interest Rate</label>
                        <div className={classes.inputContainer}>
                            <input className={classes.inputField} min="0" type="number" aria-label="interest rate" onChange={(e) => setInterestRate(parseFloat(e.target.value) || 0)} />
                            <span className={classes.inputSuffix}>%</span>
                        </div>
                    </div>
                </div>

                {/* Results and Bar */}
                <div className={classes.calculatorRight}>
                    <p>Viewing as {paymentSchedule === "Annually" ? "Annual" : paymentSchedule} Payments</p>
                    <h2>${loanAmount ? loanAmount.toFixed(2) : 0}</h2>
                    <div className={classes.barContainer}>
                        <div className={classes.barPrincipal} style={{ width: `${principalPercentage}%` }}></div>
                        <div className={classes.barInterest} style={{ width: `${interestPercentage}%` }}></div>
                    </div>

                    <div className={classes.breakdownCostsLoans}>
                        <div className={classes.costGroup}>
                            <p><strong>{principalPercentage.toFixed(0)}% Principal</strong></p>
                            <p>{monthlyPayment?.toFixed(2)} {getPeriodLabel()}</p>
                            <p>${loanAmount?.toFixed(2)} total</p>
                        </div>
                        <div className={classes.costGroup}>
                            <p><strong>{interestPercentage?.toFixed(0)}% Interest</strong></p>
                            <p>{monthlyInterest?.toFixed(2)} {getPeriodLabel()}</p>
                            <p>${totalInterest?.toFixed(2)} total</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

// Savings Calculator Component
function SavingsCalculator({ interestRate, setInterestRate }) {
    const [initialSavings, setInitialSavings] = useState(null);
    const [monthlyContribution, setMonthlyContribution] = useState(null);
    const [term, setTerm] = useState(1); // in years

    // Helpers
    const paymentSchedule = 12; // Monthly contributions
    const totalMonths = term * paymentSchedule;
    const monthlyInterestRate = interestRate / 100 / paymentSchedule;

    // Calculate Total Savings and Interest
    const calculateSavings = () => {
        let totalSaved = initialSavings;
        let totalInterest = 0;

        for (let i = 0; i < totalMonths; i++) {
            const interest = totalSaved * monthlyInterestRate; // Earned interest
            totalSaved += interest + monthlyContribution; // Add interest and new contribution
            totalInterest += interest; // Track total interest earned
        }

        return { totalSaved, totalInterest };
    };

    const { totalSaved, totalInterest } = calculateSavings();
    const totalContributions = monthlyContribution * totalMonths;

    // Percentages for visualization
    const initialSavingsPercentage = totalSaved > 0 ? (initialSavings / totalSaved) * 100 : 0;
    const contributionPercentage = totalSaved > 0 ? (totalContributions / totalSaved) * 100 : 0;
    const interestPercentage = totalSaved > 0 ? (totalInterest / totalSaved) * 100 : 0;

    return (
        <div className={classes.calculator}>
            <div className={classes.calculatorContent}>

                {/* Form */}
                <div className={classes.calculatorForm}>
                    <div className={classes.inputGroup}>
                        <label>Initial Savings</label>
                        <input type="number" value={initialSavings ?? ''} aria-label="initial savings amount" onChange={(e) => setInitialSavings(parseFloat(e.target.value) || 0)} />
                    </div>
                    <div className={classes.inputGroup}>
                        <label>Monthly Contribution</label>
                        <input type="number" value={monthlyContribution ?? ''} aria-label="monthly contributions" onChange={(e) => setMonthlyContribution(parseFloat(e.target.value) || 0)} />
                    </div>
                    <div className={classes.inputGroup}>
                        <label>Term (Years)</label>
                        <input type="number" value={term} aria-label="savings term years" onChange={(e) => setTerm(parseInt(e.target.value) || 1)} />
                    </div>
                    <div className={classes.inputGroup}>
                        <label>APY</label>
                        <div className={classes.inputContainer}>
                            <input className={classes.inputField} type="number" aria-label="annual percentage yield" value={interestRate ?? ''} onChange={(e) => setInterestRate(parseFloat(e.target.value) || 0)} />
                            <span className={classes.inputSuffix}>%</span>
                        </div>
                    </div>
                </div>

                {/* Results and Bar */}
                <div className={classes.calculatorRight}>
                    <p>Viewing as Total Earnings</p>
                    <h2>${totalSaved ? totalSaved.toFixed(2) : 0}</h2>
                    <div className={classes.barContainer}>
                        <div className={classes.barInitial} style={{ width: `${initialSavingsPercentage}%` }} ></div>
                        <div className={classes.barContributions} style={{ width: `${contributionPercentage}%` }}></div>
                        <div className={classes.barAPY} style={{ width: `${interestPercentage}%` }}></div>
                    </div>

                    <div className={classes.breakdownCostsSavings}>
                        <div className={classes.costGroup}>
                            <h4 className={classes.initialDeposit}>Initial Deposit:</h4>
                            <p>${initialSavings?.toFixed(2)}</p>
                        </div>
                        <div className={classes.costGroup}>
                            <h4 className={classes.additionalContributions}>Additional Contributions:</h4>
                            <p>${totalContributions?.toFixed(2)}</p>
                        </div>
                        <div className={classes.costGroup}>
                            <h4 className={classes.interestEarned}>Interest Earned:</h4>
                            <p>${totalInterest?.toFixed(2)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

